export enum GiveawayPrizeType {
  USDT = 'usdt',
  TON = 'ton',
  LINGO = 'lingo',
  NFT = 'nft',
}

export type GiveawayPrize = {
  amount?: number,
  type: GiveawayPrizeType,
  label?: string
  nftMetadata?: {
    name: string
    lottie: string
  }
}

export type GiveawayWinner = {
  firstName: string
  photoUrl: string | null
}

export enum LuckyRushTab {
  LIVE = 'live',
  PREVIOUS = 'previous'
}
